import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useProfile, useUIState } from 'state';
import ToggleSideBarButton from '../ToggleSideBarButton';
import { AnimatedHide, CirclePicture, FlexContainer, Txt } from 'components';
import styles from './Header.module.scss';

/**
 * Header
 *
 * @return {JSX.Element}
 */
const Header = ({ className }) => {
  const uiState = useUIState();
  const profileDoc = useProfile();
  const { data: profileData } = profileDoc;

  return (
    <FlexContainer
      className={classNames(styles.Header, className, `${Header.displayName}`)}
    >
      <AnimatedHide
        isClosed={!uiState.isSideBarClosed}
        classNameWidth={styles.ToggleButton}
        row
      >
        <ToggleSideBarButton icon="burger_closed" />
      </AnimatedHide>
      <Link to="/" className={styles.Logo}>
        <Txt bold xxxx>
          Propa
        </Txt>
      </Link>
      <FlexContainer flex justifyContentEnd>
        <Link to="profile" className={styles.ProfileLink}>
          <FlexContainer alignCenter gap>
            <FlexContainer className={styles.ProfileTitle}>
              <Txt
                x
                right
              >{`${profileData.title} ${profileData.firstName} ${profileData.lastName}`}</Txt>
            </FlexContainer>
            <CirclePicture
              src={profileData.imageUrl}
              fullText={`${profileData.firstName} ${profileData.lastName}`}
            />
          </FlexContainer>
        </Link>
      </FlexContainer>
    </FlexContainer>
  );
};

Header.displayName = 'Header';

export default observer(Header);
